import BaseModel from './BaseModel';

export default {
  ...BaseModel,

  endpoint: '/bike_transport_bike',
  getId: data => `${data.bike_transport_id}:${data.bike_id}`,
};
